import React, { useRef, useState, useEffect } from "react";
import Modal from "react-bootstrap/Modal";
import { Dimmer } from "../spinner";
import {
  validaSoloNumero,
  formatMoneda,
  validaMonto,
  formatoMonto,
  seleccionarCampo,
} from "../../util/varios";
import { Mensaje, MensajeSiNo } from "../../components/mensajes";
import "react-tabs/style/react-tabs.css";
import { TabClaseMinasDeclara } from "./modalTabClaseMinasDeclara";
import { TableBody, TableRow, TableCell } from "@material-ui/core";
import useTableScroll from "../useTableScroll";
import {
  calculoMontoPagar,
  sumaDatos,
} from "../../util/OperacionesDeclaracion";
import moment from "moment";
import axios from "axios";
import TablaDeudaMinas from "./tablaDeudaMinas";
import TablaHistoricoMinas from "./historicoDeudaMinas";

export const ModalDeclararMinas = (props) => {
  const headCells = [
    {
      id: "1",
      label: "Codigo",
      textAlign: "center",
      background: "#019cd5",
      fontSize: "10px",
      color: "white",
    },
    {
      id: "2",
      label: "Mineral / Roca / Agregado",
      textAlign: "center",
      background: "#019cd5",
      fontSize: "10px",
      color: "white",
    },
    {
      id: "3",
      label: "Alicuota",
      width: "10px",
      textAlign: "center",
      background: "#019cd5",
      fontSize: "10px",
      color: "white",
    },
    {
      id: "4",
      label: "M³",
      textAlign: "center",
      background: "#019cd5",
      fontSize: "10px",
      color: "white",
    },
    {
      id: "5",
      label: "Unidad",
      textAlign: "center",
      background: "#019cd5",
      fontSize: "10px",
      color: "white",
    },
    {
      id: "6",
      label: "Monto Bruto",
      textAlign: "center",
      background: "#019cd5",
      fontSize: "10px",
      color: "white",
    },
    {
      id: "7",
      label: "Monto a Declarar Bs",
      textAlign: "center",
      background: "#019cd5",
      fontSize: "10px",
      color: "white",
    },
    {
      id: "8",
      label: "Monto a Pagar Bs",
      textAlign: "center",
      background: "#019cd5",
      fontSize: "10px",
      color: "white",
    },
    {
      id: "9",
      label: "Fecha Declaracion",
      textAlign: "center",
      background: "#019cd5",
      fontSize: "10px",
      color: "white",
    },
  ];

  const styleInput = {
    backgroundColor: "#ffff",
    color: "#444242",
  };

  const idUsuario = JSON.parse(localStorage.getItem("idusuario"));
  const liquidador = JSON.parse(localStorage.getItem("liquidador"));
  const fechaSistema = JSON.parse(localStorage.getItem("fechasistema"));
  const anioActu = JSON.parse(localStorage.getItem("anioactu"));
  const token = localStorage.getItem("jwtToken");
  const op = require("../../../public/modulos/datos");

  const btnCancela = useRef();
  const btnSalir = useRef();
  const btnProcesar = useRef();
  const btnImprimir = useRef();
  const RefFile = useRef();

  const [mensaje, setMensaje] = useState({
    mostrar: false,
    titulo: "",
    texto: "",
    icono: "",
  });
  const [mensajesino, setMensajesino] = useState({
    mostrar: false,
    titulo: "",
    texto: "",
    icono: "",
  });
  const [mostrar, setMostrar] = useState(false);
  const [mostrar1, setMostrar1] = useState(false);
  const [mostrar2, setMostrar2] = useState(false);
  ``;
  const [mostrar7, setMostrar7] = useState(false);
  const [activate, setActivate] = useState(false);
  const [permisoElimDecla, setPermisoElimDecla] = useState();
  const [desde, setDesde] = useState(0);
  const [idDjur, setIdDjur] = useState(0);
  const [deuda, setDeuda] = useState();
  const [historico, setHistorico] = useState();
  const [totDeuda, setTotDeuda] = useState("0,00");
  const [body, setBody] = useState(null);
  const txtIdAgente = useRef();
  const cmbMes = useRef();
  const cmbAnio = useRef();
  const cmbQuincena = useRef();
  const txtDenominacionCome = useRef();
  const txtRif = useRef();
  const txtTlfContri = useRef();
  const txtNumLicencia = useRef();
  const txtDireccionContri = useRef();
  const txtNombreRespon = useRef();
  const txtCedula = useRef();
  const txtEstimado = useRef();
  const txtSaldoFavor = useRef();
  const txtReintegro = useRef();
  const txtRetenciones = useRef();
  const txtCreditoFiscal = useRef();
  const txtTotalImpuesto = useRef();
  const txtRecargo = useRef();
  const txtIntereses = useRef();
  const txtMulta = useRef();
  const txtDeducible = useRef();
  const txtMontoTotal = useRef();

  const [contar, setContar] = useState(0);
  const [contar1, setContar1] = useState(0);
  const [contar2, setContar2] = useState(0);
  const [contar3, setContar3] = useState(1);
  const [contar4, setContar4] = useState(1);
  const [contar5, setContar5] = useState(0);
  const [contar6, setContar6] = useState(0);
  const [contar7, setContar7] = useState(0);
  const [deshabilitado, setDeshabilitado] = useState(false);
  const [deshabilitadoP, setDeshabilitadoP] = useState(true);
  const [deshabilitadoI, setDeshabilitadoI] = useState(false);
  const [relacion, setRelacion] = useState({
    idagente: null,
    mes: null,
    anio: null,
    valido: true,
  });
  const [operacion, setOperacion] = useState(0);
  const [operacionPer, setOperacionPer] = useState(0);
  const [tabIndex, setTabIndex] = useState(0);
  const [anio, setAnio] = useState([]);
  const [comerAct, setComerAct] = useState();
  const [claseMinaxAgen, setClaseMinaxAgen] = useState();
  const [radioTipo, setRadioTipo] = useState("1");
  const [datoUT, setDatoUT] = useState([]);
  const [datoCalculo, setDatoCalculo] = useState([]);
  const [visibleDefi, setVisibleDefi] = useState("hidden");
  const [visibleRegu, setVisibleRegu] = useState("visible");
  const [visibleCmbQ, setVisibleCmbQ] = useState("hidden");
  const [records, setRecords] = useState([]);
  const [pdf, setPdf] = useState("");
  const [pathImage, setPathImage] = useState("Seleccionar Archivo");

  const { TblContainer, TblHead, TblPagination, recordsAfterPagingAndSorting } =
    useTableScroll(records, headCells, {
      fn: (items) => {
        return items;
      },
    });

  const selectDjurada = (idagente, anio, mes, tipo) => {
    let endpoint = `${op.conexion}/api/minas/djuradaminasagente?idagente=${idagente}&anio=${anio}&mes=${mes}&tipo=${tipo}`;

    axios
      .get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
        },
      })
      .then(function (response) {
        if (response.status == 200) {
          setActivate(false);
          var totImpu = parseFloat("0.00");
          var monDedu = parseFloat("0.00");
          var sfavor = parseFloat("0.00");
          var totPagar = parseFloat("0.00");
          var monEst = parseFloat("0.00");
          setContar4(1);
          setIdDjur(0);
          setRecords(response.data);
          console.log(response.data);
          if (response.data.length > 0) {
            setRelacion({
              idagente: response.data[0].idagente,
              mes: response.data[0].nummes,
              anio: cmbAnio.current.value,
              valido: false,
            });
            setDeshabilitado(true);
            setDeshabilitadoI(true);
            setIdDjur(response.data[0].iddjuradaminas);
            for (let a = 0; a < response.data.length; a++) {
              totImpu += parseFloat(response.data[a].montoapagar);
            }

            monDedu =
              parseFloat(response.data[0].retenciones) +
              parseFloat(response.data[0].creditofavor);
            totPagar =
              totImpu +
              parseFloat(response.data[0].recargo) +
              parseFloat(response.data[0].interes) +
              parseFloat(response.data[0].multa) -
              monDedu;
            txtRetenciones.current.value = formatMoneda(
              response.data[0].retenciones.toString().replace(".", ","),
              ",",
              ".",
              2
            );
            txtCreditoFiscal.current.value = formatMoneda(
              response.data[0].creditofavor.toString().replace(".", ","),
              ",",
              ".",
              2
            );
            txtTotalImpuesto.current.value = formatMoneda(
              totImpu.toFixed(2).toString().replace(".", ","),
              ",",
              ".",
              2
            );
            txtRecargo.current.value = formatMoneda(
              response.data[0].recargo.toString().replace(".", ","),
              ",",
              ".",
              2
            );
            txtIntereses.current.value = formatMoneda(
              response.data[0].interes.toString().replace(".", ","),
              ",",
              ".",
              2
            );
            txtMulta.current.value = formatMoneda(
              response.data[0].multa.toString().replace(".", ","),
              ",",
              ".",
              2
            );
            txtDeducible.current.value = formatMoneda(
              monDedu.toFixed(2).toString().replace(".", ","),
              ",",
              ".",
              2
            );
            if (totPagar < 0) {
              txtSaldoFavor.current.value = formatMoneda(
                (totPagar * -1).toFixed(2).toString().replace(".", ","),
                ",",
                ".",
                2
              );
              txtMontoTotal.current.value = "0,00";
              sfavor = (totPagar * -1).toFixed(2);
            } else {
              txtSaldoFavor.current.value = "0,00";
              txtMontoTotal.current.value = formatMoneda(
                totPagar.toFixed(2).toString().replace(".", ","),
                ",",
                ".",
                2
              );
              sfavor = parseFloat("0.00").toFixed(2);
            }
          } else {
            setDeshabilitado(false);
            setDeshabilitadoI(false);
            setRelacion({
              idagente: null,
              mes: null,
              anio: null,
              valido: true,
            });
          }
        }
      })
      .catch(function (error) {
        setActivate(false);
        setMensaje({
          mostrar: true,
          titulo: "Error",
          texto: error.response.data.message,
          icono: "error",
        });
      });
  };

  const selectDatCal = (idagente, anio, mes, tipo, fecha) => {
    let endpoint = `${op.conexion}/api/minas/datoscalculodeclaminas?idagente=${idagente}&anio=${anio}&mes=${mes}&tipo=${tipo}&fecha=${fecha}`;

    axios
      .get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
        },
      })
      .then(function (response) {
        if (response.status == 200) {
          setDatoCalculo(response.data);
          setDeshabilitadoI(true);
          let data = [...records];
          var resu = [];
          let tipDec =
            radioTipo === "3" && cmbQuincena.current.value === "2"
              ? "4"
              : radioTipo;
          resu = sumaDatos(
            records,
            cmbAnio.current.value,
            cmbMes.current.value,
            response.data,
            tipDec,
            txtRetenciones.current.value,
            txtReintegro.current.value
          );
          txtReintegro.current.value = resu[0].acredit;
          txtCreditoFiscal.current.value = resu[0].credito;
          txtTotalImpuesto.current.value = resu[0].impuesto;
          txtRecargo.current.value = resu[0].recargos;
          txtIntereses.current.value = resu[0].intereses;
          txtMulta.current.value = resu[0].multa;
          txtDeducible.current.value = resu[0].montodeducible;
          txtSaldoFavor.current.value = resu[0].saldofavor;
          txtMontoTotal.current.value = resu[0].totalpagar;
        }
      })
      .catch(function (error) {
        setActivate(false);
        setMensaje({
          mostrar: true,
          titulo: "Error",
          texto: error.response.data.message,
          icono: "error",
        });
      });
  };

  const selectUT = (idagente, anio, mes, tipo, fecha, totdeuda) => {
    let endpoint = `${op.conexion}/api/minas/valorutminas?idagente=${idagente}&anio=${anio}&mes=${mes}&tipo=${tipo}&fecha=${fecha}&totdeuda=${totdeuda}`;

    axios
      .get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
        },
      })
      .then(function (response) {
        if (response.status == 200) {
          setDatoUT(response.data);
          let data = [...props.tabclaseminaxagen];
          var resu = [];
          let tipDec =
            radioTipo === "2" && cmbQuincena.current.value === "2"
              ? "3"
              : radioTipo;

          resu = calculoMontoPagar(
            props.tabclaseminaxagen,
            response.data,
            cmbAnio.current.value,
            tipDec,
            props.config.calculaminimo
          );
          for (let i = 0; i < resu.length; i++) {
            for (let x = 0; x < resu[i].activi.length; x++) {
              if (operacion === 1) {
                data[x].montoapagar = "0.00";
                data[x].montodeclarado = "0.00";
              } else {
                data[x].montoapagar = resu[i].activi[x].montoapagar;
              }
            }
          }
          setClaseMinaxAgen(data);
          setMostrar2(true);
        }
      })
      .catch(function (error) {
        setMensaje({
          mostrar: true,
          titulo: "Error",
          texto: error.response.data.message,
          icono: "error",
        });
      });
  };

  const SelectDeudaAgenMina = (idagente) => {
    let endpoint = `${
      op.conexion
    }/api/minas/deudas?idagente=${idagente}&fecha=${fechaSistema}&tabconf=${"configminas"}&condic=${"tipodeuda=1"}`;

    axios
      .get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
        },
      })
      .then(function (response) {
        if (response.status == 200) {
          var deu = [];
          var his = [];
          var totdeu = parseFloat(0.0);
          for (let i = 0; i < response.data.length; i++) {
            if (response.data[i].fechapago === null) {
              totdeu =
                totdeu +
                parseFloat(response.data[i].mondeu) +
                parseFloat(response.data[i].intmoradeu) +
                parseFloat(response.data[i].recargodeu) +
                parseFloat(response.data[i].multa);
              deu.push({
                anio: response.data[i].anio,
                mes: response.data[i].mes.replace("'", "").replace("'", ""),
                monto: response.data[i].mondeu,
                intereses: response.data[i].intmoradeu,
                recargo: response.data[i].recargodeu,
                multa: response.data[i].multa,
                retenciones: response.data[i].retencion,
                credito: response.data[i].acreditacion,
                totalperi: response.data[i].subtotal,
                status: response.data[i].estatus,
                idfac: response.data[i].idfact,
                nummes: response.data[i].nmes,
                estatusfac: response.data[i].estatusfac,
                tipotransaccion: response.data[i].tipotransaccion,
              });
            } else {
              his.push({
                anio: response.data[i].anio,
                mes: response.data[i].mes.replace("'", "").replace("'", ""),
                monto: response.data[i].mondeu,
                intereses: response.data[i].intmoradeu,
                recargo: response.data[i].recargodeu,
                multa: response.data[i].multa,
                descuento: response.data[i].mondescue,
                recibo: response.data[i].numreci,
                fechapago: response.data[i].fechapago,
                status: response.data[i].estatus,
                idfac: response.data[i].idfact,
                estatusfac: response.data[i].estatusfac,
                tipotransaccion: response.data[i].tipotransaccion,
              });
            }
          }
          setTotDeuda(
            formatMoneda(totdeu.toString().replace(".", ","), ",", ".", 2)
          );
          setDeuda(deu);
          setHistorico(his);
        }
        setActivate(false);
      })
      .catch(function (error) {
        setMensaje({
          mostrar: true,
          titulo: "Error",
          texto: error.response.data.message,
          icono: "error",
        });
        setActivate(false);
      });
  };

  const procesarDeclaracion = () => {
    let endpoint = `${op.conexion}/api/minas/actualizardjuradaminas`;

    axios
      .post(endpoint, body, {
        headers: {
          "x-access-token": `${token}`,
        },
      })
      .then(function (response) {
        if (response.status == 200) {
          if (response.data) {
            setActivate(false);

            setDesde(0);
            setMensaje({
              mostrar: true,
              titulo: "Procesar Declaración",
              texto:
                "La declaración ha sido procesada de manera satisfactoria.",
              icono: "exito",
            });
            setContar(1);
            setContar5(1);
            blanquear();
            let tipDec =
              radioTipo === "2" && cmbQuincena.current.value === "2"
                ? "3"
                : radioTipo;
            seleccionarDjurada(tipDec);
            SelectDeudaAgenMina(props.agente.idagente);
          }
        }
      })
      .catch(function (error) {
        setActivate(false);
        setMensaje({
          mostrar: true,
          titulo: "Error",
          texto: error.response.data.message,
          icono: "error",
        });
      });
  };

  const eliminaDeclaracion = () => {
    let endpoint = `${op.conexion}/api/minas/eliminardjuradaminas`;

    axios
      .post(endpoint, body, {
        headers: {
          "x-access-token": `${token}`,
        },
      })
      .then(function (response) {
        if (response.status == 200) {
          if (response.data) {
            setActivate(false);
            setMensaje({
              mostrar: true,
              titulo: "Eliminar Declaración",
              texto:
                "La declaración del mes de " +
                cmbMes.current[cmbMes.current.selectedIndex].text +
                " se eliminó de manera satisfactoria.",
              icono: "exito",
            });
            setDesde(0);
            setContar(1);
            setContar5(1);
            blanquear();
            let tipDec =
              radioTipo === "2" && cmbQuincena.current.value === "2"
                ? "3"
                : radioTipo;
            seleccionarDjurada(tipDec);
            SelectDeudaAgenMina(props.agente.idagente);
          }
        }
      })
      .catch(function (error) {
        setActivate(false);
        setMensaje({
          mostrar: true,
          titulo: "Error",
          texto: error.response.data.message,
          icono: "error",
        });
      });
  };

  const seleccionarDjurada = (tipoDec) => {
    setActivate(true);
    setContar(0);
    selectDjurada(
      props.agente.idagente,
      parseInt(cmbAnio.current.value, 10),
      cmbMes.current[cmbMes.current.selectedIndex].text,
      parseInt(tipoDec, 10)
    );
  };

  const handleChangeRadio = (event) => {
    event.preventDefault();
    setContar3(0);
    setRadioTipo(event.target.value);
    txtTotalImpuesto.current.value = "0,00";
    txtMontoTotal.current.value = "0,00";
    txtSaldoFavor.current.value = "0,00";
    txtDeducible.current.value = "0,00";
    txtReintegro.current.value = "0,00";
    txtCreditoFiscal.current.value = "0,00";
    txtRetenciones.current.value = "0,00";
    txtIntereses.current.value = "0,00";
    txtRecargo.current.value = "0,00";
    txtEstimado.current.value = "0,00";
    if (event.target.value === "1") {
      setVisibleRegu("visible");
      setVisibleDefi("hidden");
      if (
        parseInt(
          props.config.aniodesdequincena !== null && cmbAnio.current.value,
          10
        ) >= props.config.aniodesdequincena
      ) {
        if (
          props.config.mesdesdequincena !== null &&
          cmbMes.current.value >= props.config.mesdesdequincena
        ) {
          setVisibleCmbQ("visible");
          setRadioTipo("2");
        } else {
          setVisibleCmbQ("hidden");
        }
      } else {
        setVisibleCmbQ("hidden");
      }
    } else if (event.target.value === "2") {
      setVisibleRegu("visible");
      setVisibleDefi("hidden");
      if (
        props.config.aniodesdequincena !== null &&
        parseInt(cmbAnio.current.value, 10) >= props.config.aniodesdequincena
      ) {
        if (
          props.config.mesdesdequincena !== null &&
          cmbMes.current.value < props.config.mesdesdequincena
        ) {
          setVisibleCmbQ("visible");
        } else {
          setRadioTipo("1");
          setVisibleCmbQ("hidden");
        }
      } else {
        setRadioTipo("1");
        setVisibleCmbQ("hidden");
      }
    }
  };

  const cancelar = (e) => {
    e.preventDefault();
    setContar(1);
    setContar5(1);
    blanquear();
  };

  const handleUpload = (e) => {
    if (e.target.files && e.target.files.length > 0) {
      const file = e.target.files[0];
      console.log(file);
      const name = e.target;
      if (file.size > 1000000) {
        setMensaje({
          mostrar: true,
          titulo: "Notificacion",
          texto: "El peso maximo del archivo es 1000kb.",
          icono: "informacion",
        });
      }

      if (file.size <= 1000000) {
        setPathImage(file.name);
        setPdf(e.target.files[0]);
      }

      /*                 const reader = new FileReader()
                            reader.readAsDataURL(file)
                
                            if (name.name === 'declaracion') {
                                reader.onload = function load() {
                                    setPathImage('')
                                }
                            }
                         */
    }
  };

  const mensajeArchivo = () => {
    setMensaje({
      mostrar: true,
      titulo: "Notificacion",
      texto:
        "Debe cargar el archivo con la relación de ventas en formato pdf, el peso maximo del archivo es 1000kb.",
      icono: "informacion",
    });
  };

  const salir = (e) => {
    e.preventDefault();
    props.onHideCancela();
    setContar(1);
    setContar5(1);
    setContar3(1);
    blanquear();
  };

  const handleCloseSi = () => {
    setMensajesino({ mostrar: false, titulo: "", texto: "", icono: "" });
    if (desde === 0) {
      setActivate(true);
      procesarDeclaracion();
    } else {
      setActivate(true);
      eliminaDeclaracion();
    }
  };

  const handleCmbMes = (event) => {
    event.preventDefault();
    txtTotalImpuesto.current.value = "0,00";
    txtMontoTotal.current.value = "0,00";
    txtSaldoFavor.current.value = "0,00";
    txtDeducible.current.value = "0,00";
    txtCreditoFiscal.current.value = "0,00";
    txtRetenciones.current.value = "0,00";
    txtIntereses.current.value = "0,00";
    txtRecargo.current.value = "0,00";

    let tipDec =
      radioTipo === "2" && cmbQuincena.current.value === "2" ? "3" : radioTipo;
    if (
      props.config.aniodesdequincena !== null &&
      parseInt(cmbAnio.current.value, 10) >= props.config.aniodesdequincena
    ) {
      if (
        props.config.mesdesdequincena !== null &&
        event.target.value >= props.config.mesdesdequincena
      ) {
        if (tipDec === "1") {
          setVisibleCmbQ("visible");
          setRadioTipo("2");
          tipDec = "2";
        }
      } else {
        if (tipDec === "2") {
          setRadioTipo("1");
          setVisibleCmbQ("hidden");
          tipDec = "1";
        }
      }
    } else {
      if (tipDec === "2") {
        setVisibleCmbQ("hidden");
        setRadioTipo("1");
        tipDec = "1";
      }
    }
    seleccionarDjurada(tipDec);
  };

  const handleCmbAnio = (event) => {
    event.preventDefault();
    txtTotalImpuesto.current.value = "0,00";
    txtMontoTotal.current.value = "0,00";
    txtSaldoFavor.current.value = "0,00";
    txtDeducible.current.value = "0,00";
    txtCreditoFiscal.current.value = "0,00";
    txtRetenciones.current.value = "0,00";
    txtIntereses.current.value = "0,00";
    txtRecargo.current.value = "0,00";

    let tipDec =
      radioTipo === "3" && cmbQuincena.current.value === "2" ? "4" : radioTipo;
    if (
      props.config.aniodesdequincena !== null &&
      parseInt(event.target.value, 10) >= props.config.aniodesdequincena
    ) {
      if (
        props.config.mesdesdequincena !== null &&
        cmbMes.current.value >= props.config.mesdesdequincena
      ) {
        if (tipDec === "1") {
          setVisibleCmbQ("visible");
          setRadioTipo("2");
          tipDec = "2";
        }
      } else {
        if (tipDec === "2") {
          setRadioTipo("1");
          setVisibleCmbQ("hidden");
          tipDec = "1";
        }
      }
    } else {
      if (tipDec === "2") {
        setVisibleCmbQ("hidden");
        setRadioTipo("1");
        tipDec = "1";
      }
    }
    seleccionarDjurada(tipDec);
  };

  const onChangeValidar = (e) => {
    e.preventDefault();
    var sigue = true;
    var siguepdf = true;

    if (records.length === 0) {
      setMensaje({
        mostrar: true,
        titulo: "Notificacion",
        texto: "Las actividades a declarar no deben estar vacias.",
        icono: "informacion",
      });
      sigue = false;
      setTabIndex(0);
    }

    if (sigue) {
      var clasexagen = [];
      var djur = [];
      var peri = 0;
      var totdecla = parseFloat(0.0);
      var totpag = parseFloat(0.0);
      var totm3 = parseFloat(0.0);
      var totunidad = parseFloat(0.0);
      var totbruto = parseFloat(0.0);
      var fecdec;

      let tipDec =
        radioTipo === "2" && cmbQuincena.current.value === "2"
          ? parseInt("3")
          : parseInt(radioTipo);

      for (let i = 0; i < records.length; i++) {
        if (i === 0) {
          fecdec = records[i].fechadeclaracion;
        }
        totdecla = totdecla + parseFloat(records[i].montodeclarado);
        totpag = totpag + parseFloat(records[i].montoapagar);
        totm3 = totm3 + parseFloat(records[i].montometrocubico);
        totunidad = totunidad + parseFloat(records[i].montounidad);
        totbruto = totbruto + parseFloat(records[i].montobruto);

        clasexagen.push({
          idclaseminas: records[i].idclaseminas,
          montodeclarado: records[i].montodeclarado,
          montoapagar: records[i].montoapagar,
          montometrocubico: records[i].montometrocubico,
          montounidad: records[i].montounidad,
          montobruto: records[i].montobruto,
        });
      }

      djur.push({
        iddjurada: operacion === 1 ? 0 : idDjur,
        montototaldeclarado: totdecla,
        montototalapagar: totpag,
        montototalmetrocubico: totm3,
        montototalunidad: totunidad,
        montototalbruto: totbruto,
        fechadeclaracion: fecdec,
        anio: cmbAnio.current.value,
        mes: cmbMes.current[cmbMes.current.selectedIndex].text,
        nummes: cmbMes.current.value,
        tipo: tipDec,
        liquidador: idUsuario,
        valorpetro: props.config.valorpetro,
        retenciones: txtRetenciones.current.value
          .replace(/\./g, "")
          .replace(",", "."),
        creditofavor: txtCreditoFiscal.current.value
          .replace(/\./g, "")
          .replace(",", "."),
        recargo: txtRecargo.current.value.replace(/\./g, "").replace(",", "."),
        interes: txtIntereses.current.value
          .replace(/\./g, "")
          .replace(",", "."),
        multa: txtMulta.current.value.replace(/\./g, "").replace(",", "."),
      });

      if (pdf === "" && totpag > 0.0) {
        setMensaje({
          mostrar: true,
          titulo: "Notificacion",
          texto: "Debe cargar el archivo con la relación de ventas pdf.",
          icono: "informacion",
        });
        RefFile.current.focus();
        siguepdf = false;
      }

      if (siguepdf) {
        let upload = new FormData();

        upload.append("idagen", parseInt(props.agente.idagente, 10));
        upload.append("fechasis", fechaSistema);
        upload.append("idusu", idUsuario);
        upload.append("djur", JSON.stringify(djur));
        upload.append("clasexagen", JSON.stringify(clasexagen));
        upload.append("dirip", localStorage.getItem("ip"));
        upload.append("dirmac", localStorage.getItem("mac"));
        upload.append("peri", props.config.peripago);
        upload.append("numpago", props.config.numpago);
        upload.append("txtrif", txtRif.current.value);
        upload.append(
          "periodo",
          cmbMes.current.value + "-" + cmbAnio.current.value
        );
        upload.append("declaracion", pdf);

        setBody(upload);

        setDesde(0);
        setContar2(0);
        let msg = "Esta Seguro de Procesar la Declaración?.";
        setMensajesino({
          mostrar: true,
          titulo: "Confirmación.",
          texto: msg,
          icono: "confirmacion",
        });
      }

      /*             setBody({
                            idagen: parseInt(props.agente.idagente, 10),
                            fechasis: fechaSistema,
                            idusu: idUsuario,
                            djur: JSON.stringify(djur),
                            clasexagen: JSON.stringify(clasexagen),
                            dirip: localStorage.getItem('ip'),
                            dirmac: localStorage.getItem('mac'),
                            peri: props.config.peripago,
                            numpago: props.config.numpago,
                            txtrif: txtRif.current.value
                        }); */
    }
  };

  const agregarActividades = (event) => {
    event.preventDefault();
    if (props.tabclaseminaxagen.length > 0) {
      setClaseMinaxAgen(props.tabclaseminaxagen);
      setOperacion(1);
      setContar5(0);
      let tipDec =
        radioTipo === "2" && cmbQuincena.current.value === "2"
          ? "3"
          : radioTipo;
      selectUT(
        parseInt(props.agente.idagente, 10),
        cmbAnio.current.value,
        cmbMes.current.value,
        tipDec,
        fechaSistema,
        totDeuda.trim()
      );
    } else {
      setMensaje({
        mostrar: true,
        titulo: "Notificacion",
        texto:
          "No hay actividades asociadas para el año: " + cmbAnio.current.value,
        icono: "informacion",
      });
    }
  };

  const eliminarDeclaracion = () => {
    if (records.length > 0) {
      let tipDec =
        radioTipo === "2" && cmbQuincena.current.value === "2"
          ? parseInt("3")
          : parseInt(radioTipo);

      setContar7(0);
      setBody({
        cmes: cmbMes.current[cmbMes.current.selectedIndex].text,
        dirip: localStorage.getItem("ip"),
        dirmac: localStorage.getItem("mac"),
        fechasis: fechaSistema,
        idagen: parseInt(props.agente.idagente, 10),
        idusu: idUsuario,
        montotot: txtMontoTotal.current.value
          .trim()
          .replace(/\./g, "")
          .replace(",", "."),
        nanio: parseInt(cmbAnio.current.value),
        nmes: parseInt(cmbMes.current.value),
        tipodec: tipDec,
      });
      setDesde(1);
      let msg = "Esta Seguro de Eliminar la Declaración?.";
      setMensajesino({
        mostrar: true,
        titulo: "Confirmación.",
        texto: msg,
        icono: "confirmacion",
      });
    } else {
      setMensaje({
        mostrar: true,
        titulo: "Notificacion",
        texto:
          "No hay actividades asociadas para el año: " + cmbAnio.current.value,
        icono: "informacion",
      });
    }
  };

  const cerrarModalAgragarActi = () => {
    setClaseMinaxAgen(props.tabactixcomer);
    setMostrar2(false);
  };

  const validarAgregarActi = (claseMinaxAgen) => {
    setDeshabilitadoP(false);
    setContar4(0);
    console.log(claseMinaxAgen);
    setRecords(claseMinaxAgen);
    setMostrar2(false);
  };

  const handleInputMontoChange = (event) => {
    validaMonto(event);
    if (event.which === 13 || typeof event.which === "undefined") {
      if (
        event.target.value === "" ||
        parseFloat(
          event.target.value.trim().replace(".", "").replace(",", ".")
        ) === 0.0
      ) {
        event.target.value = "0,00";
      }
      event.target.value = formatoMonto(event.target.value);
      let char1 = event.target.value.substring(0, 1);
      let char2 = event.target.value.substring(1, 2);
      if (char1 === "0" && char2 !== ",") {
        event.target.value = event.target.value.substring(
          1,
          event.target.value.legth
        );
      }
      if (
        event.target.id === "inputReintegro" ||
        event.target.id === "inputRetenciones"
      ) {
        var monDedu;
        var totPagar;
        var sFavor;
        monDedu =
          parseFloat(
            txtReintegro.current.value.replace(/\./g, "").replace(",", ".")
          ) +
          parseFloat(
            txtRetenciones.current.value.replace(/\./g, "").replace(",", ".")
          ) +
          parseFloat(
            txtCreditoFiscal.current.value.replace(/\./g, "").replace(",", ".")
          );
        monDedu = Math.round(monDedu * Math.pow(10, 2)) / Math.pow(10, 2);
        totPagar =
          parseFloat(
            txtTotalImpuesto.current.value.replace(/\./g, "").replace(",", ".")
          ) +
          parseFloat(
            txtRecargo.current.value.replace(/\./g, "").replace(",", ".")
          ) +
          parseFloat(
            txtIntereses.current.value.replace(/\./g, "").replace(",", ".")
          ) +
          parseFloat(
            txtMulta.current.value.replace(/\./g, "").replace(",", ".")
          ) -
          monDedu -
          parseFloat(
            txtEstimado.current.value.replace(/\./g, "").replace(",", ".")
          );
        totPagar = Math.round(totPagar * Math.pow(10, 2)) / Math.pow(10, 2);

        if (totPagar < 0.0) {
          sFavor = totPagar * -1;
          sFavor = Math.round(sFavor * Math.pow(10, 2)) / Math.pow(10, 2);
          totPagar = parseFloat(0.0);
        } else {
          sFavor = parseFloat(0.0);
        }
        txtDeducible.current.value = formatMoneda(
          monDedu.toString().replace(".", ","),
          ",",
          ".",
          2
        );
        txtSaldoFavor.current.value = formatMoneda(
          sFavor.toString().replace(".", ","),
          ",",
          ".",
          2
        );
        txtMontoTotal.current.value = formatMoneda(
          totPagar.toString().replace(".", ","),
          ",",
          ".",
          2
        );
      }
      if (event.which === 13) {
        if (event.target.id === "inputDeducible") {
          btnSalir.current.focus();
        } else if (
          event.target.id === "inputReintegro" ||
          event.target.id === "inputRetenciones"
        ) {
          btnProcesar.current.focus();
        }
      }
    } else if (event.which === 46) {
      return false;
    } else if (event.which >= 48 && event.which <= 57) {
      return true;
    } else if (event.which === 8 || event.which === 0 || event.which === 44) {
      return true;
    } else return false;
  };

  const imprimirOficina = () => {
    var idfactura, tipodeuda;
    tipodeuda = "PlanillaOficinaMina";
    idfactura =
      " dj.idagente =" +
      txtIdAgente.current.value +
      " and dj.nummes = " +
      cmbMes.current.value +
      " and dj.anio =" +
      cmbAnio.current.value;
    window.open(
      op.reportes + "FACTURA=" + idfactura + "&reporte=" + tipodeuda,
      "Planilla",
      "fullscreen=no,scrollbars=yes,toolbar=no,resizable=no,width=850,height=700"
    );
  };

  const imprimirRelacion = () => {
    window.open(
      `${op.imagenesweb}dm-${txtIdAgente.current.value}-${cmbMes.current.value}-${cmbAnio.current.value}.pdf`,
      "Planilla",
      "fullscreen=no,scrollbars=yes,toolbar=no,resizable=no,width=850,height=700"
    );
  };

  const blanquear = () => {
    setOperacionPer(0);
    setMostrar(false);
    setMostrar1(false);
    setActivate(false);
    setDeshabilitadoP(true);
    setDeshabilitadoI(false);
    setContar4(1);
    setRecords([]);
    setPdf("");
    setRelacion({
      idagente: null,
      mes: null,
      anio: null,
      valido: true,
    });
    setPathImage("Seleccionar Archivo");
    txtTotalImpuesto.current.value = "0,00";
    txtMontoTotal.current.value = "0,00";
    txtSaldoFavor.current.value = "0,00";
    txtDeducible.current.value = "0,00";
    txtReintegro.current.value = "0,00";
    txtCreditoFiscal.current.value = "0,00";
    txtRetenciones.current.value = "0,00";
    txtIntereses.current.value = "0,00";
    txtRecargo.current.value = "0,00";
    txtEstimado.current.value = "0,00";
  };

  useEffect(() => {
    var nanio = [];
    var aini = 2008;
    var afin = parseInt(anioActu, 10);
    for (let i = 0; i <= afin - aini; i++) {
      nanio.push({ anio: aini + i });
    }

    setAnio(nanio);

    if (props.operacion) {
      setOperacion(props.operacion);
    }

    if (props.tabclaseminaxagen) {
      setClaseMinaxAgen(props.tabclaseminaxagen);
    }
  }, [props.tabclaseminaxagen, props.agente, props.operacion, radioTipo]);

  useEffect(() => {
    if (contar3 === 0 && radioTipo && cmbAnio.current && cmbMes.current) {
      let tipDec =
        radioTipo === "2" && cmbQuincena.current.value === "2"
          ? "3"
          : radioTipo;
      setContar3(1);
      seleccionarDjurada(tipDec);
    }
  }, [contar3]);

  useEffect(() => {
    if (contar4 === 0 && records) {
      let tipDec =
        radioTipo === "2" && cmbQuincena.current.value === "2"
          ? "3"
          : radioTipo;
      setContar4(1);
      setContar6(0);
      selectDatCal(
        parseInt(props.agente.idagente, 10),
        cmbAnio.current.value,
        cmbMes.current.value,
        tipDec,
        fechaSistema
      );
    }
  }, [records]);

  return (
    <Modal
      {...props}
      size="xl"
      aria-labelledby="contained-modal-title-vcenter"
      centered
      backdrop="static"
      keyboard={false}
      onShow={() => {
        setVisibleCmbQ("hidden");
        setContar4(1);
        setRecords([]);
        setContar3(0);
        setRadioTipo("1");
        setVisibleRegu("visible");
        setVisibleDefi("hidden");
        if (anio) {
          cmbAnio.current.value = anio[anio.length - 1].anio;
        }

        if (
          props.config.aniodesdequincena !== null &&
          parseInt(cmbAnio.current.value, 10) >= props.config.aniodesdequincena
        ) {
          if (
            props.config.mesdesdequincena !== null &&
            cmbMes.current.value >= props.config.mesdesdequincena
          ) {
            setVisibleCmbQ("visible");
            setRadioTipo("1");
          } else {
            setVisibleCmbQ("hidden");
          }
        } else {
          setVisibleCmbQ("hidden");
        }
        props.operacion < 3 ? txtRif.current.focus() : btnSalir.current.focus();

        setOperacion(props.operacion);
        setClaseMinaxAgen(
          props.tabclaseminaxagen ? props.tabclaseminaxagen : []
        );
        setTabIndex(0);
        setContar1(0);
        setDeuda(props.tabdeuda);
        setHistorico(props.tabpago);
        setTotDeuda(props.totdeuda);
      }}
    >
      <Modal.Header className="azulGradiant2">
        <Modal.Title style={{ color: "#fff" }}>
          Registro de Declaraciones Minas
        </Modal.Title>
        <button
          ref={btnSalir}
          disabled={!deshabilitadoP}
          className="btn"
          style={{ border: 0, margin: 0, padding: 0, color: "#ffffff" }}
          onClick={salir}
        >
          <i className="far fa-window-close"></i>
        </button>
      </Modal.Header>
      <Modal.Body>
        <Dimmer active={activate} />
        <TabClaseMinasDeclara
          show={mostrar2}
          onHideCancela={cerrarModalAgragarActi}
          onHideAcepta={validarAgregarActi}
          operacion={operacion}
          tabaclaseminasxagen={claseMinaxAgen}
          idagente={props.agente ? props.agente.idagente : ""}
          mes={
            cmbMes.current
              ? cmbMes.current[cmbMes.current.selectedIndex].text
              : ""
          }
          nmes={cmbMes.current ? cmbMes.current.value : ""}
          anio={cmbAnio.current ? cmbAnio.current.value : ""}
          tipodecla={
            radioTipo === "2" &&
            cmbAnio.current &&
            cmbQuincena.current.value === "2"
              ? "3"
              : radioTipo
          }
          datoCalculo={datoUT}
          totdeuda={totDeuda}
          config={props.config}
        />
        <div
          className="px-3"
          style={{ height: "80vh", margin: 0, overflow: "scroll" }}
        >
          <ul className="nav nav-tabs mb-3" id="ex-with-icons" role="tablist">
            <li className="nav-item " role="presentation">
              <a
                className="nav-link text-dark rounded"
                style={{ backgroundColor: "#25d366" }}
                id="ex-with-icons-tab-1"
                data-mdb-toggle="tab"
                href="#ex-with-icons-tabs-1"
                role="tab"
                aria-controls="ex-with-icons-tabs-1"
                aria-selected="true"
              >
                <i className="fas mx-2 fa-folder-minus"></i>Declaraciones
                Juradas
              </a>
            </li>
            <li className="nav-item" role="presentation">
              <a
                className="nav-link text-dark rounded"
                style={{ backgroundColor: "#55acee" }}
                id="ex-with-icons-tab-2"
                data-mdb-toggle="tab"
                href="#ex-with-icons-tabs-2"
                role="tab"
                aria-controls="ex-with-icons-tabs-2"
                aria-selected="false"
              >
                {" "}
                <i className="fas mx-2 fa-money-bill"></i> Relación de Deuda
                Vencida
              </a>
            </li>
            <li className="nav-item" role="presentation">
              <a
                className="nav-link text-light rounded"
                style={{ backgroundColor: "#F93154" }}
                id="ex-with-icons-tab-3"
                data-mdb-toggle="tab"
                href="#ex-with-icons-tabs-3"
                role="tab"
                aria-controls="ex-with-icons-tabs-3"
                aria-selected="false"
              >
                <i className="fas mx-2 fa-credit-card"></i>Relación de Pagos
              </a>
            </li>
          </ul>

          <div className="tab-content" id="ex-with-icons-content">
            <div
              className="tab-pane fade show active"
              id="ex-with-icons-tabs-1"
              role="tabpanel"
              aria-labelledby="ex-with-icons-tab-1"
            >
              <div>
                <div
                  className="row rounded py-2 px-0 d-flex justify-content-between"
                  style={{ margin: 0, padding: 0 }}
                >
                  <div className="row col-md-12 d-flex p-0 px-2 justify-content-between">
                    <div className="input-group input-group-sm col-sm-2">
                      <label
                        className="input-group-text"
                        id="inputGroup-sizing-sm"
                      >
                        Código:
                      </label>
                      <input
                        type="text"
                        readOnly
                        ref={txtIdAgente}
                        className="form-control form-control-sm "
                        defaultValue={props.agente ? props.agente.idagente : ""}
                        id="inputCodigo"
                        style={styleInput}
                      />
                    </div>

                    <div className="input-group input-group-sm col-sm-2">
                      <label
                        className="input-group-text"
                        id="inputGroup-sizing-sm"
                      >
                        Año:
                      </label>
                      <select
                        name=""
                        disabled={!deshabilitadoP}
                        ref={cmbAnio}
                        className="form-control form-control-sm "
                        onChange={handleCmbAnio}
                        style={styleInput}
                      >
                        {anio &&
                          anio.map((a) => (
                            <option key={a.anio} value={a.anio}>
                              {a.anio}
                            </option>
                          ))}
                      </select>
                    </div>

                    <div className="input-group input-group-sm col-sm-2">
                      <label
                        className="input-group-text"
                        id="inputGroup-sizing-sm"
                      >
                        Mes:
                      </label>
                      <select
                        name=""
                        disabled={!deshabilitadoP}
                        ref={cmbMes}
                        className="form-control form-control-sm"
                        onChange={handleCmbMes}
                        style={styleInput}
                      >
                        <option key="0" value="1">
                          ENERO
                        </option>
                        <option key="1" value="2">
                          FEBRERO
                        </option>
                        <option key="2" value="3">
                          MARZO
                        </option>
                        <option key="3" value="4">
                          ABRIL
                        </option>
                        <option key="4" value="5">
                          MAYO
                        </option>
                        <option key="5" value="6">
                          JUNIO
                        </option>
                        <option key="6" value="7">
                          JULIO
                        </option>
                        <option key="7" value="8">
                          AGOSTO
                        </option>
                        <option key="8" value="9">
                          SEPTIEMBRE
                        </option>
                        <option key="9" value="10">
                          OCTUBRE
                        </option>
                        <option key="10" value="11">
                          NOVIEMBRE
                        </option>
                        <option key="11" value="12">
                          DICIEMBRE
                        </option>
                      </select>
                    </div>

                    <div
                      className="row col-sm-4"
                      style={{ visibility: "hidden" }}
                    >
                      <label
                        className="col-sm-5 px-1"
                        style={{ fontWeight: "bold" }}
                      >
                        Tipo Declaración:
                      </label>
                      <div className="form-check form-check-inline col-sm-3 px-0">
                        <input
                          style={
                            !deshabilitadoP
                              ? { pointerEvents: "none", opacity: "0.7" }
                              : {}
                          }
                          className="form-check-input"
                          type="radio"
                          name="radioTipoDecla"
                          value="1"
                          checked={radioTipo === "1"}
                          onChange={handleChangeRadio}
                        />
                        <label
                          className="form-check-label"
                          htmlFor="inlineRadio3"
                        >
                          {"Mensual"}
                        </label>
                      </div>
                      <div className="form-check form-check-inline col-sm-3 px-0">
                        <input
                          style={
                            !deshabilitadoP
                              ? { pointerEvents: "none", opacity: "0.7" }
                              : {}
                          }
                          className="form-check-input"
                          type="radio"
                          name="radioTipoDecla"
                          value="2"
                          checked={radioTipo === "2"}
                          onChange={handleChangeRadio}
                        />
                        <label
                          className="form-check-label"
                          htmlFor="inlineRadio3"
                        >
                          Quincenal
                        </label>
                      </div>
                    </div>

                    <div className="input-group input-group-sm col-sm-2">
                      <label id="inputGroup-sizing-sm">Valor U.C:</label>
                      <div className="col-md-4" style={{ textAlign: "left" }}>
                        <label htmlFor="inputRitm">
                          {props.config
                            ? formatMoneda(
                                props.config.valorpetro
                                  .replace(",", "")
                                  .replace(".", ","),
                                ",",
                                ".",
                                2
                              )
                            : "0,00"}
                        </label>
                      </div>
                    </div>
                  </div>

                  <div className="text-success" style={{ marginTop: "1%" }}>
                    <h3>Datos del Contribuyente</h3>
                    <hr />
                  </div>

                  <div className="col-sm-6 row">
                    <div className="input-group input-group-sm py-1 col-sm-3">
                      <label
                        className="input-group-text"
                        id="inputGroup-sizing-sm"
                      >
                        Rif:
                      </label>
                      <input
                        type="text"
                        readOnly
                        ref={txtRif}
                        maxLength={15}
                        className="form-control form-control-sm"
                        placeholder="123456789"
                        id="inputRif"
                        defaultValue={
                          props.agente ? props.agente.rif.trim() : ""
                        }
                        style={styleInput}
                      />
                    </div>

                    <div className="input-group input-group-sm py-1 col-sm-9">
                      <label
                        className="input-group-text"
                        id="inputGroup-sizing-sm"
                      >
                        Denominación Comercial:
                      </label>
                      <input
                        type="text"
                        readOnly
                        ref={txtDenominacionCome}
                        className="form-control form-control-sm"
                        defaultValue={
                          props.agente ? props.agente.nombre.trim() : ""
                        }
                        id="inputDenoComer"
                        style={styleInput}
                      />
                    </div>

                    <div className="input-group input-group-sm py-1 col-sm-6">
                      <label
                        className="input-group-text"
                        id="inputGroup-sizing-sm"
                      >
                        Nº de Teléfono:
                      </label>
                      <input
                        type="text"
                        readOnly
                        ref={txtTlfContri}
                        className="form-control form-control-sm"
                        id="inputTlfContri"
                        placeholder="0000-0000000"
                        defaultValue={
                          props.agente
                            ? props.agente.telefono !== null
                              ? props.agente.telefono.trim()
                              : ""
                            : ""
                        }
                        style={styleInput}
                      />
                    </div>

                    <div className="input-group input-group-sm py-1 col-sm-6">
                      <label
                        className="input-group-text"
                        id="inputGroup-sizing-sm"
                      >
                        Nº de Licencia:
                      </label>
                      <input
                        type="text"
                        readOnly
                        ref={txtNumLicencia}
                        className="form-control form-control-sm"
                        defaultValue={
                          props.agente
                            ? props.agente.nrolicenciamina !== null
                              ? props.agente.nrolicenciamina.trim()
                              : ""
                            : ""
                        }
                        id="inputNumLicencia"
                        style={styleInput}
                      />
                    </div>
                  </div>

                  <div className="col-sm-6 row">
                    <div className="input-group input-group-sm py-1 col-sm-8">
                      <label
                        className="input-group-text"
                        id="inputGroup-sizing-sm"
                      >
                        Nombre Representante:
                      </label>
                      <input
                        type="text"
                        readOnly
                        ref={txtNombreRespon}
                        className="form-control form-control-sm"
                        id="inputNomResponsable"
                        defaultValue={
                          props.representante
                            ? props.representante.nombres.trim() +
                              " " +
                              props.representante.apellidos.trim()
                            : ""
                        }
                        style={styleInput}
                      />
                    </div>

                    <div className="input-group input-group-sm py-1 col-sm-4">
                      <label
                        className="input-group-text"
                        id="inputGroup-sizing-sm"
                      >
                        Cédula:
                      </label>
                      <input
                        type="text"
                        readOnly
                        ref={txtCedula}
                        className="form-control form-control-sm"
                        id="inputCedula"
                        defaultValue={
                          props.representante ? props.representante.cedula : ""
                        }
                        style={styleInput}
                      />
                    </div>

                    <div className="input-group input-group-sm py-1 col-sm-12">
                      <label
                        className="input-group-text"
                        id="inputGroup-sizing-sm"
                      >
                        Dirección:
                      </label>
                      <textarea
                        type="text"
                        readOnly
                        ref={txtDireccionContri}
                        className="form-control form-control-sm"
                        id="inputDireccionContri"
                        defaultValue={
                          props.agente
                            ? props.agente.direccion !== null
                              ? props.agente.direccion.trim()
                              : ""
                            : ""
                        }
                        style={styleInput}
                      />
                    </div>
                  </div>
                </div>

                <div className="row col-md-12" style={{ padding: "5px" }}>
                  <div
                    className="text-success d-flex-justify-content-between row col-sm-12"
                    style={{ marginTop: "1%" }}
                  >
                    <h3 className="col-sm-3">Datos de la Declaración Mina</h3>
                    <div className="col-sm-6"></div>
                    <div
                      className="col-md-3 d-flex justify-content-end"
                      style={{ padding: 0 }}
                    >
                      <button
                        disabled={deshabilitadoI}
                        className="btn btn-sm btn-primary rounded-pill"
                        onClick={agregarActividades}
                        style={{ fontSize: "10px", height: 30 }}
                      >
                        <i className="fa fa-plus"> Incluir</i>{" "}
                      </button>
                    </div>

                    <hr />
                  </div>
                  <div className="col-md-5">
                    <h3
                      style={{
                        margin: "0",
                        textAlign: "center",
                        color: "blue",
                      }}
                    >
                      {records && records.length > 0 && records[0].pagada
                        ? "La Declaración está Pagada"
                        : ""}
                    </h3>
                  </div>
                </div>
                <div
                  className="col-md-12"
                  style={{ backgroundColor: "#ffffff" }}
                  id="printJS-form"
                >
                  <TblContainer>
                    <TblHead />

                    <TableBody>
                      {records &&
                        records.map((dju, index) => (
                          <TableRow style={{ padding: "0" }} key={index}>
                            <TableCell
                              style={{ fontSize: "10px", textAlign: "center" }}
                            >
                              {dju.codigoclaseminas}
                            </TableCell>
                            <TableCell
                              style={{ fontSize: "10px", textAlign: "left" }}
                            >
                              {dju.descripcion}
                            </TableCell>
                            <TableCell
                              style={{ fontSize: "10px", textAlign: "right" }}
                            >
                              {formatMoneda(
                                dju.alicuota.replace(",", "").replace(".", ","),
                                ",",
                                ".",
                                2
                              )}
                            </TableCell>
                            <TableCell
                              style={{ fontSize: "10px", textAlign: "right" }}
                            >
                              {formatMoneda(
                                dju.montometrocubico
                                  .replace(",", "")
                                  .replace(".", ","),
                                ",",
                                ".",
                                2
                              )}
                            </TableCell>
                            <TableCell
                              style={{ fontSize: "10px", textAlign: "right" }}
                            >
                              {formatMoneda(
                                dju.montounidad
                                  .replace(",", "")
                                  .replace(".", ","),
                                ",",
                                ".",
                                2
                              )}
                            </TableCell>
                            <TableCell
                              style={{ fontSize: "10px", textAlign: "right" }}
                            >
                              {formatMoneda(
                                dju.montobruto
                                  .replace(",", "")
                                  .replace(".", ","),
                                ",",
                                ".",
                                2
                              )}
                            </TableCell>
                            <TableCell
                              style={{ fontSize: "10px", textAlign: "right" }}
                            >
                              {formatMoneda(
                                dju.montodeclarado
                                  .replace(",", "")
                                  .replace(".", ","),
                                ",",
                                ".",
                                2
                              )}
                            </TableCell>
                            <TableCell
                              style={{ fontSize: "10px", textAlign: "right" }}
                            >
                              {formatMoneda(
                                dju.montoapagar
                                  .replace(",", "")
                                  .replace(".", ","),
                                ",",
                                ".",
                                2
                              )}
                            </TableCell>
                            <TableCell
                              style={{ fontSize: "10px", textAlign: "center" }}
                            >
                              {moment(dju.fechadeclaracion).format(
                                "DD/MM/YYYY"
                              )}
                            </TableCell>
                          </TableRow>
                        ))}
                    </TableBody>
                  </TblContainer>
                </div>
                <div className="row col-md-12" style={{ margin: "0px" }}>
                  <div className="rounder row col-md-3 border border-primary">
                    <div
                      className="col-md-12"
                      style={{ visibility: visibleDefi }}
                    >
                      <h4>Estimado Año Anterior</h4>
                    </div>
                    <div
                      className="col-md-6"
                      style={{ visibility: visibleDefi }}
                    >
                      <label style={{ marginLeft: "5px" }} htmlFor="inputRitm">
                        Total Estimado:
                      </label>
                    </div>
                    <div
                      className="col-md-6"
                      style={{ visibility: visibleDefi }}
                    >
                      <input
                        type="text"
                        ref={txtEstimado}
                        className="form-control form-control-sm"
                        style={{ marginBottom: "0px", textAlign: "right" }}
                        id="inputTotalEstimado"
                        defaultValue="0,00"
                        onFocus={seleccionarCampo}
                        onKeyUp={handleInputMontoChange}
                        onBlur={handleInputMontoChange}
                      />
                    </div>
                    <div
                      className="row col-md-12"
                      style={{
                        visibility: deshabilitadoP ? "hidden" : "visible",
                      }}
                    >
                      <label
                        htmlFor="formFile"
                        className="form-label col-md-10"
                        style={{
                          cursor: "pointer",
                          color: "#FFFFFF",
                          backgroundColor: "#42a5f5",
                          padding: "5px 10px",
                          borderRadius: "5px",
                          border: "1px ridge black",
                          fontSize: 14,
                          height: "auto",
                        }}
                      >
                        <i
                          className="fas fa-file-pdf"
                          style={{ color: "#8b0000", fontSize: 14 }}
                        />{" "}
                        {pathImage === "Seleccionar Archivo"
                          ? "Adjuntar Relación de Ventas"
                          : pathImage}
                      </label>
                      <button
                        className="rounded-circle btn btn-outline-info col-md-2"
                        title="Debe cargar el archivo con la relación de ventas en formato pdf, el peso maximo del archivo es 1000kb."
                        onClick={mensajeArchivo}
                        style={{ marginLeft: 5, borderColor: "transparent" }}
                      >
                        <i className="fas fa-exclamation"></i>
                      </button>
                      <input
                        className="form-control"
                        hidden={true}
                        ref={RefFile}
                        name="declaracion"
                        accept=".pdf"
                        onChange={handleUpload}
                        type="file"
                        id="formFile"
                      />
                    </div>
                    <div
                      className="col-md-12"
                      style={{
                        visibility: relacion.valido ? "hidden" : "visible",
                      }}
                    >
                      <button
                        disabled={relacion.valido}
                        onClick={imprimirRelacion}
                        className="btn btn-sm btn-primary"
                      >
                        <i className="fa fa-print"> Relación de Ventas</i>{" "}
                      </button>
                    </div>
                    <div
                      className="col-md-12"
                      style={{
                        visibility:
                          (records &&
                            records.length > 0 &&
                            records[0].pagada) ||
                          (records && records.length === 0) ||
                          (permisoElimDecla &&
                            permisoElimDecla.substring(1, 2) !== "1")
                            ? "hidden"
                            : "visible",
                      }}
                    >
                      {/*  <button disabled={!deshabilitadoP} onClick={imprimirRelacion} className="btn btn-sm btn-primary"  ><i className="fa fa-print"> Relación de Ventas</i> </button> */}
                      <button
                        disabled={!deshabilitadoP}
                        className="btn btn-sm btn-danger"
                        style={{ marginTop: "50%" }}
                        onClick={eliminarDeclaracion}
                      >
                        <i className="fa fa-trash-alt">
                          {" "}
                          Eliminar Declaración y Deuda
                        </i>{" "}
                      </button>
                    </div>
                  </div>
                  <div className="row col-md-5" style={{ marginTop: "5px" }}>
                    <div className="col-md-4" style={{ visibility: "hidden" }}>
                      <label style={{ marginLeft: "5px" }} htmlFor="inputRitm">
                        Acreditación:
                      </label>
                    </div>
                    <div
                      className="row col-md-6"
                      style={{ visibility: "hidden" }}
                    >
                      <div className="col-md-10">
                        <input
                          type="text"
                          disabled={deshabilitado}
                          ref={txtReintegro}
                          className="form-control form-control-sm"
                          style={{ textAlign: "right" }}
                          id="inputReintegro"
                          defaultValue="0,00"
                          onFocus={seleccionarCampo}
                          onKeyUp={handleInputMontoChange}
                          onBlur={handleInputMontoChange}
                        />
                      </div>
                    </div>
                    <div className="col-md-4" style={{ visibility: "hidden" }}>
                      <label style={{ marginLeft: "5px" }} htmlFor="inputRitm">
                        % Retenciones:
                      </label>
                    </div>
                    <div
                      className="row col-md-6"
                      style={{ visibility: "hidden" }}
                    >
                      <div className="col-md-10">
                        <input
                          type="text"
                          ref={txtRetenciones}
                          className="form-control form-control-sm"
                          style={{ textAlign: "right" }}
                          id="inputRetenciones"
                          defaultValue="0,00"
                          onFocus={seleccionarCampo}
                          onKeyUp={handleInputMontoChange}
                          onBlur={handleInputMontoChange}
                        />
                      </div>
                    </div>
                    <div className="col-md-4">
                      <label
                        style={{ marginLeft: "5px" }}
                        htmlFor="inputRitm"
                      ></label>
                    </div>
                    <div className="row col-md-6">
                      <div className="col-md-10"></div>
                      <div className="col-md-2"></div>
                    </div>
                    <div className="col-md-4">
                      <label
                        style={{ marginLeft: "5px" }}
                        htmlFor="inputRitm"
                      ></label>
                    </div>
                    <div className="row col-md-6">
                      <div className="col-md-10"></div>
                      <div className="col-md-2"></div>
                    </div>
                    <div className="col-md-4">
                      <label style={{ marginLeft: "5px" }} htmlFor="inputRitm">
                        Saldo a Favor:
                      </label>
                    </div>
                    <div className="row col-md-6">
                      <div className="col-md-10">
                        <input
                          type="text"
                          readOnly
                          ref={txtSaldoFavor}
                          className="form-control form-control-sm"
                          style={{ textAlign: "right" }}
                          id="inputISLR"
                          defaultValue="0,00"
                        />
                      </div>
                      <div className="col-md-2"></div>
                    </div>
                    <div className="col-md-4">
                      <label style={{ marginLeft: "5px" }} htmlFor="inputRitm">
                        Credito Fiscal:
                      </label>
                    </div>
                    <div className="row col-md-6">
                      <div className="col-md-10">
                        <input
                          type="text"
                          readOnly
                          ref={txtCreditoFiscal}
                          className="form-control form-control-sm"
                          style={{ textAlign: "right" }}
                          id="inputCreditoFiscal"
                          defaultValue="0,00"
                        />
                      </div>
                      <div className="col-md-2"></div>
                    </div>
                  </div>
                  <div className="rounder row col-md-4 border border-primary">
                    <div className="col-md-12">
                      <h4>Totales</h4>
                    </div>
                    <div className="col-md-6">
                      <label htmlFor="inputRitm">Total Impuesto:</label>
                    </div>
                    <div className="col-md-6">
                      <input
                        type="text"
                        readOnly
                        ref={txtTotalImpuesto}
                        className="form-control form-control-sm"
                        style={{ marginBottom: "5px", textAlign: "right" }}
                        id="inputNumRegistro"
                        defaultValue="0,00"
                      />
                    </div>
                    <div
                      className="col-md-6"
                      style={{ visibility: visibleRegu }}
                    >
                      <label htmlFor="inputRitm">
                        {props.config
                          ? formatMoneda(
                              props.config.porrecargo
                                .toString()
                                .replace(".", ","),
                              ",",
                              ".",
                              2
                            ) + "% Recargos:"
                          : "% Recargos:"}
                      </label>
                    </div>

                    <div
                      className="col-md-6"
                      style={{ visibility: visibleRegu }}
                    >
                      <input
                        type="text"
                        readOnly
                        ref={txtRecargo}
                        className="form-control form-control-sm"
                        style={{ marginBottom: "5px", textAlign: "right" }}
                        id="inputFechaInscripcion"
                        defaultValue="0,00"
                      />
                    </div>
                    <div className="col-md-6">
                      <label htmlFor="inputRitm">
                        {props.config
                          ? formatMoneda(
                              props.config.porinteres
                                .toString()
                                .replace(".", ","),
                              ",",
                              ".",
                              2
                            ) + "% Intereses:"
                          : "% Intereses:"}
                      </label>
                    </div>

                    <div className="col-md-6">
                      <input
                        type="text"
                        readOnly
                        ref={txtIntereses}
                        className="form-control form-control-sm"
                        style={{ textAlign: "right", marginBottom: "5px" }}
                        id="inputISLR"
                        defaultValue="0,00"
                      />
                    </div>
                    <div
                      className="col-md-6"
                      style={{ visibility: visibleRegu }}
                    >
                      <label htmlFor="inputRitm">Multa:</label>
                    </div>

                    <div
                      className="col-md-6"
                      style={{ visibility: visibleRegu }}
                    >
                      <input
                        type="text"
                        readOnly
                        ref={txtMulta}
                        className="form-control form-control-sm"
                        style={{ textAlign: "right", marginBottom: "5px" }}
                        id="inputCapPag"
                        defaultValue="0,00"
                      />
                    </div>
                    <div className="col-md-6">
                      <label htmlFor="inputRitm">Impuesto Deducible:</label>
                    </div>

                    <div className="col-md-6">
                      <input
                        type="text"
                        readOnly
                        ref={txtDeducible}
                        className="form-control form-control-sm"
                        style={{ textAlign: "right", marginBottom: "5px" }}
                        id="inputDeducible"
                        defaultValue="0,00"
                        onFocus={seleccionarCampo}
                        onKeyUp={handleInputMontoChange}
                        onBlur={handleInputMontoChange}
                      />
                    </div>
                    <div className="col-md-6">
                      <label htmlFor="inputRitm">Monto Total a Pagar Bs:</label>
                    </div>

                    <div className="col-md-6">
                      <input
                        type="text"
                        readOnly
                        ref={txtMontoTotal}
                        className="form-control form-control-sm"
                        style={{ textAlign: "right", marginBottom: "5px" }}
                        id="inputCapSub"
                        defaultValue="0,00"
                      />
                    </div>
                  </div>
                </div>
              </div>

              <div
                className="col-sm-12 row d-flex justify-content-end py-2"
                style={{ marginTop: "2%" }}
              >
                <button
                  ref={btnProcesar}
                  disabled={deshabilitadoP}
                  /*disabled={permisoElimDecla ? permisoElimDecla.substring(2, 3) !== "1" ? true : deshabilitadoP : true}*/ onClick={
                    onChangeValidar
                  }
                  className="mx-2 rounded-pill btn btn-success col-md-2"
                  style={{ height: "35px", fontSize: "12px" }}
                >
                  <i className="fas fa-check-circle"> Procesar Declaración</i>
                </button>
                <button
                  ref={btnImprimir}
                  disabled={
                    records && records.length > 0 && deshabilitadoP
                      ? false
                      : true
                  }
                  onClick={imprimirOficina}
                  className="mx-2 rounded-pill btn btn-primary col-md-2"
                  style={{ height: "35px", fontSize: "12px" }}
                >
                  <i className="fas fa-print"> Imprimir</i>
                </button>
                <button
                  ref={btnCancela}
                  disabled={deshabilitadoP}
                  onClick={cancelar}
                  className="mx-2 rounded-pill btn btn-secondary col-md-2"
                  style={{ height: "35px", fontSize: "12px" }}
                >
                  <i className="fas fa-window-close"> Cancelar</i>
                </button>
                <button
                  ref={btnSalir}
                  disabled={!deshabilitadoP}
                  onClick={salir}
                  className="mx-2 rounded-pill btn btn-danger col-md-2"
                  style={{ height: "35px", fontSize: "12px" }}
                >
                  <i className="fa fa-sign-out"> Salir</i>
                </button>
              </div>
            </div>
            <div
              className="tab-pane fade"
              id="ex-with-icons-tabs-2"
              role="tabpanel"
              aria-labelledby="ex-with-icons-tab-2"
            >
              <TablaDeudaMinas
                tabdeuda={deuda}
                agente={props.agente}
                credito={props.agente ? props.agente.credito : "0,00"}
              />
            </div>
            <div
              className="tab-pane fade"
              id="ex-with-icons-tabs-3"
              role="tabpanel"
              aria-labelledby="ex-with-icons-tab-3"
            >
              <TablaHistoricoMinas tabpago={historico} />
            </div>
          </div>
          {/* Tabs content */}
        </div>
      </Modal.Body>

      <Mensaje
        mensaje={mensaje}
        onHide={() =>
          setMensaje({ mostrar: false, titulo: "", texto: "", icono: "" })
        }
      />
      <MensajeSiNo
        mensaje={mensajesino}
        onHideNo={() =>
          setMensajesino({ mostrar: false, titulo: "", texto: "", icono: "" })
        }
        onHideSi={handleCloseSi}
      />
    </Modal>
  );
};



// WEBPACK FOOTER //
// ./src/components/minas/modalDeclararMinas.js